import { Action, Context } from "state/_types"

export const selectVehicle: Action<string|null> = async ({ state }: Context, vehicleId) => {
    state.vehicles.currentItemId = vehicleId
} 